@if (!pending) {
    @if (displayEntities?.data.length > 0) {
        <div>
            <table class="table w-100 bg-light" mat-table matSort [dataSource]="displayEntities">
                <ng-container matColumnDef="loadDate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'ui.history-table.date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">
                        {{ upload.inDate | date: calendarFormat }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="fileName">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.file' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.fileName }}</td>
                </ng-container>

                <ng-container matColumnDef="operType">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'ui.history-table.op' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.operType }}</td>
                </ng-container>

                <ng-container matColumnDef="rideIssued">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'b2b.table-number-of-trips-uploads.th.rideIssued' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.rideIssued }}</td>
                </ng-container>

                <ng-container matColumnDef="logs">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.logs' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">
                        @if (upload.errFmtAmount > 0) {
                            <span
                                class="a a--black"
                                role="link"
                                tabindex="0"
                                [attr.title]="'b2b.table-number-of-trips-uploads.aria.downloadParsingReport' | translate"
                                (click)="downloadParsingErrorReport(upload)">
                                {{ 'b2b.table-number-of-trips-uploads.logs.parsing' | translate }}
                            </span>
                            <span class="mx-1">/</span>
                        }
                        @if (upload.dbErrAmount > 0) {
                            <span
                                class="a a--black"
                                role="link"
                                tabindex="0"
                                [attr.title]="'b2b.table-number-of-trips-uploads.aria.downloadDbReport' | translate"
                                (click)="downloadDbErrorReport(upload)">
                                {{ 'b2b.table-number-of-trips-uploads.logs.db' | translate }}
                            </span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="errors">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'global.labels.error' | translate }}
                    </th>

                    <td mat-cell *matCellDef="let upload">
                        @let totalError = upload.errFmtAmount + upload.dbErrAmount;
                        <span [class.text-success]="totalError === 0" [class.text-danger]="totalError > 0">
                            {{ totalError }}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr class="tr--cursor-default" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    } @else {
        <ui-no-matches />
    }
} @else {
    <ui-pre-loader [narrow]="true" />
}

<paginator [source]="displayEntities" />
